import type { FilterRuleModel } from '@/shared/generated'

import { z } from 'zod'

const basicFilters = z.discriminatedUnion('operation', [
	z.object({
		name: z.string().min(1),
		operation: z.literal(['bl', 'is_empty', 'is_not_empty']),
		value: z.union([
			z.literal('1'),
			z.literal('0'),
			z.boolean(),
			z.literal(1),
			z.literal(0),
		]),
	}),
	z.object({
		name: z.string().min(1),
		operation: z.literal('num_between'),
		value: z.tuple([z.number(), z.number()]),
	}),
	z.object({
		name: z.string().min(1),
		operation: z.literal([
			'select',
			'is',
			'is_not',
			'contains',
			'not_contains',
		]),
		value: z.string().min(1).trim(),
	}),
	z.object({
		name: z.string().min(1),
		operation: z.literal(['in', 'not_in']),
		value: z.array(z.string().trim().nullable()).nonempty(),
	}),
	z.object({
		name: z.string().min(1),
		operation: z.literal([
			'array_all_of',
			'array_any_of',
			'array_exact',
			'array_none_of',
		]),
		value: z.array(z.string().trim()),
	}),
	z.object({
		name: z.string().min(1),
		operation: z.literal(['eq', 'ne', 'gt', 'gte', 'lt', 'lte']),
		value: z.number(),
	}),
	z.object({
		name: z.string().min(1),
		operation: z.literal(['date_after', 'date_before', 'date_at']),
		value: z.iso.date(),
	}),
	z.object({
		name: z.string().min(1),
		operation: z.literal(['date_between']),
		value: z.tuple([z.iso.date(), z.iso.date()]),
	}),
])
const referenceFilters = z.object({
	name: z.string().min(1),
	operation: z.literal([
		'gt',
		'lt',
		'lte',
		'gte',
		'eq',
		'ne',
		'select',
		'is',
		'is_not',
		'contains',
		'not_contains',
		'in',
		'not_in',
		'array_any_of',
		'array_all_of',
		'array_none_of',
		'array_exact',
		'date_after',
		'date_before',
		'date_at',
		'bl',
	]),
	reference: z.string(),
})
export const filterSchema = z.union([basicFilters, referenceFilters])
export const filtersSchema = z.array(filterSchema)

export type FilterSchema = z.infer<typeof filterSchema>
export type FiltersSchema = z.infer<typeof filtersSchema>

export const validateFilter = (filter: FilterRuleModel) =>
	filterSchema.safeParse(filter)
export const validateFilters = (filters: FilterRuleModel[]) =>
	filtersSchema.safeParse(filters)
